<div class="{{ platform() }}">
    @if (src()) {
        <img [src]="src()" />
    }
    @if (showStatus()) {
        <div class="status-bubble {{ status() }}"></div>
    }
</div>
